// @flow

import { useEffect, useMemo } from 'react';
import { type Tenant } from '@tectonics/commons/tenant';
import { useLocalTenancyAsTenant } from '@tectonics/controller/context';
import { useIncomingPayment } from './context';
import { fetchIncomingPayment } from './fetch-incoming-payment';
import { getHash } from './get-hash';
import { getStatus } from './get-status';

export function useReloadAfterPaymentGetItsStatusChanged(refreshInterval: number = 10000) {
  const incomingPayment = useIncomingPayment();
  const paymentHash = useMemo(() => getHash(incomingPayment), [incomingPayment]);
  const lastPaymentStatus =  useMemo(() => getStatus(incomingPayment), [incomingPayment]);
  const tenant = useLocalTenancyAsTenant();

  useEffect(() => {
    const interval = setInterval(async () => {
      await queryPaymentAndReloadIfStatusChanged(paymentHash, interval, lastPaymentStatus, tenant);
    }, refreshInterval);

    return () => clearInterval(interval);
  }, [paymentHash, refreshInterval, tenant]);
}

async function queryPaymentAndReloadIfStatusChanged(paymentHash: string, interval: IntervalID, lastPaymentStatus: string, tenant: Tenant) {
  // Purposefully ignoring errors as this function is called inside setInterval and will be executed again
  const payment = await fetchIncomingPayment(paymentHash, tenant)
    .catch(() => null);

  if (payment === null) {
    return;
  }

  const currentPaymentStatus = getStatus(payment);

  if (lastPaymentStatus !== currentPaymentStatus) {
    clearInterval(interval);
    window.location.reload();
  }
}
